import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import './tokens.css'

const root = ReactDOM.createRoot(document.getElementById('root'));

const testingState = 'prod'

let authDomain, redirectUri;
if (testingState === 'testing') {
  authDomain = 'dev-hldt17c2gz1xk402.eu.auth0.com'
  redirectUri = 'http://localhost:3000'
} else if (testingState === 'prod') {
  authDomain = 'www.pattern-inc.io'
  redirectUri = 'https://pattern-inc.io'
}

root.render(
  <Auth0Provider
      domain={authDomain}
      clientId={process.env.REACT_APP_CUBE_CLIENT_ID}
      authorizationParams={{
        redirect_uri: redirectUri + '/'
      }}
    >
    <App testingState={testingState} />
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
